import { Box, Grid, IconButton, LinearProgress, Tooltip, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useState } from 'react';
import { gridSpacing } from 'store/constant';
import MainCard from 'ui-component/cards/MainCard';
import ProjectTable from 'views/Projects/ProjectTable';
import ProjectsFirestoreService from 'views/Projects/ServiceProject';
import ApproveBudget from 'views/dashboard/Default/ApproveBudget';
import PendingBudget from 'views/dashboard/Default/PendingBudget';
import TotalBudget from 'views/dashboard/Default/TotalBudget';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { useSelector } from 'react-redux';
import DependencyService from 'views/DependenciesManagement/DependencyService';
import DownloadIcon from '@mui/icons-material/Download';
import { useRef } from 'react';

const MPPending = () => {
  const [projects, setProjects] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [totalBudget, setTotalBudget] = useState(0);
  const [approveBudget, setApproveBudget] = useState(0);
  const [pendingBudget, setPendingBudget] = useState(0);

  const user = useSelector((state) => state.user?.user);
  const projectTableRef = useRef();

  const handleExportClick = () => {
    if (projectTableRef?.current) {
      projectTableRef.current.exportToExcel();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { dependence, role } = JSON.parse(user?.reloadUserInfo?.customAttributes);

        const dependenciesChildren = await DependencyService.getDependenciesChildren(dependence);

        const handlePendingUsersUpdate = (data) => {
          setProjects(data);
          setLoading(false);
        };

        const filterOptions =
          role !== 'ADMIN_ROLE'
            ? {
                dependencies: [...dependenciesChildren.map((item) => item.dependence), dependence],
                status: ['Enviado', 'Revisado', 'Preparando Propuesta', 'Pendiente', 'Pendiente Aprobación']
              }
            : { status: ['Enviado', 'Revisado', 'Preparando Propuesta', 'Pendiente', 'Pendiente Aprobación'] };

        const unsubscribe = ProjectsFirestoreService.subscribeToProjects(handlePendingUsersUpdate, filterOptions);

        return () => {
          unsubscribe();
        };
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    let value = 0;
    projects.map((project) => {
      value = value + Number(project.presupuestoRequerido);
    });
    setTotalBudget(value);
  }, [projects]);

  useEffect(() => {
    let value = 0;
    projects
      .filter((project) => project.status === 'Aprobado')
      .map((project) => {
        value = value + Number(project.presupuestoRequerido);
      });
    setApproveBudget(value);
  }, [projects]);

  useEffect(() => {
    let value = 0;
    projects
      .filter((project) => project.status === 'Pendiente')
      .map((project) => {
        value = value + Number(project.presupuestoRequerido);
      });
    setPendingBudget(value);
  }, [projects]);

  return (
    <div style={{ marginTop: '20px' }}>
      <Grid container spacing={gridSpacing} marginBottom={2}>
        <Grid item xs={12}>
          <Grid container spacing={gridSpacing}>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TotalBudget isLoading={isLoading} value={totalBudget} />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <ApproveBudget isLoading={isLoading} value={approveBudget} />
            </Grid>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <PendingBudget isLoading={isLoading} value={pendingBudget} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <MainCard
        title={
          <Grid container justifyContent={'center'} alignItems={'center'}>
            <Grid item xs={12}>
              <Typography variant="h1" component="h2">
                Proyectos pendientes
              </Typography>
              <Typography variant="h4">
                Lista los proyectos que estan en proceso de construcción de propuesta o pendiente por aprobación
              </Typography>
            </Grid>
          </Grid>
        }
        secondary={
          <Grid container justifyContent={'center'}>
            <Tooltip title="Exportar a Excel">
              <IconButton onClick={handleExportClick} aria-label="download" color="info">
                <DownloadIcon style={{ width: 50, height: 50 }} />
              </IconButton>
            </Tooltip>
            <Box>
              <PendingActionsIcon style={{ width: 60, height: 60 }} />
            </Box>
          </Grid>
        }
      >
        {isLoading && <LinearProgress />}
        <ProjectTable ref={projectTableRef} projects={projects} />
      </MainCard>
    </div>
  );
};

export default MPPending;
